import { UpsellComponentsConfig, UpsellStaticTemplateSchema } from '@/modules/Upsell/instances/@types/upsell-types'

const config: UpsellStaticTemplateSchema = {
	id: 'upsell-static-assessment-result',
	config: {
		static: true,
		background: 'green-gradient',
		analytics: {
			show: {
				amplitudeTitle: 'SUBSCRIPTION_UPSELL_AFTER_ASSESSMENT_SCREEN',
				title: null,
			},
		},
	},
	order: ['UpsellStaticAssessmentResult'],
	components: {
		UpsellStaticAssessmentResult: ({ $t }): UpsellComponentsConfig['UpsellStaticAssessmentResult'] => ({
			buttonText: $t('common.controls.continue'),
		}),
	},
}

export default config
